/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCameraMovie: {
  name: 'camera-movie';
  data: string;
} = {
  name: 'camera-movie',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm7.83 4H16a2 2 0 0 1 2 2v2.15l.438-.549c1.181-1.476 3.562-.64 3.562 1.25v4.298c0 1.89-2.38 2.726-3.562 1.25L18 17.85V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h.535a4 4 0 1 1 7.1-3.672A3 3 0 0 1 15.829 8ZM13 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM4 20V10h12v10H4Zm14.28-5L20 12.85v4.3L18.28 15Z" fill="currentColor"/></svg>`,
};
